import * as React from 'react';
import NavbarComponent from './Navbar';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <main className='min-h-[100dvh] w-full text-base font-sans relative antialiased'>
      <NavbarComponent />
      <div className='w-full mb-10'>{children}</div>
    </main>
  );
}
